// Moves column `from` to the place of column `to` in a saved column order.
// Dragging right puts it after `to`, dragging left puts it before.
export const moveColumn = (cols, from, to) => {
  if (from === to || !cols.includes(from) || !cols.includes(to)) return cols;
  const next = cols.filter((k) => k !== from);
  const at = next.indexOf(to) + (cols.indexOf(from) < cols.indexOf(to) ? 1 : 0);
  next.splice(at, 0, from);
  return next;
};
